import * as THREE from 'three';

export const buildTrackingPath = (curve: THREE.Curve<THREE.Vector3>, points: THREE.Vector3[]) => {
  if (points.length === 0) {
    return curve;
  }

  const blendFactor = 0.5;
  const influenceRadius = curve.getLength() * blendFactor;

  return new THREE.CatmullRomCurve3(
    curve.getPoints(Math.round(influenceRadius * 0.1)).map((_, index, cpoints) => {
      const current =
        cpoints[Math.floor(index + cpoints.length - cpoints.length * 0.05) % cpoints.length];
      const weightedSum = new THREE.Vector3();
      let totalWeight = 0;

      points.forEach((point) => {
        const distance = current.distanceTo(point);

        if (distance < influenceRadius) {
          const weight = (influenceRadius - distance) / influenceRadius;
          weightedSum.add(point.clone().multiplyScalar(weight));
          totalWeight += weight;
        }
      });

      if (totalWeight > 0) {
        const avgP = weightedSum.divideScalar(totalWeight);
        return new THREE.Vector3(
          current.x * (1 - blendFactor) + avgP.x * blendFactor,
          current.y * (1 - blendFactor) + avgP.y * blendFactor,
          current.z * (1 - blendFactor) + avgP.z * blendFactor,
        );
      }
      return current;
    }),
  );
};
